import React from 'react';
import RestShow from 'containers/rest/Show';
import RestFieldItem from 'components/RestField/RestFieldItem';

const NichesShow = props => (
  <RestShow {...props} hasEdit resource="niches">
    <RestFieldItem source="name" header="niches.name" />
    <RestFieldItem source="description" header="niches.description" />
    <RestFieldItem source="isDelete" header="niches.isDelete" />
  </RestShow>
);

export default NichesShow;
